import {Component, input, OnInit, output} from '@angular/core';
import {BehaviorSubject, Observable, switchMap, tap} from 'rxjs';
import {ObjectRangeOption, ObjektDataService} from '../../../services/objekt-data.service';
import {MatSelectChange} from '@angular/material/select';
import {filter} from 'rxjs/operators';
import {takeUntilDestroyed, toObservable} from '@angular/core/rxjs-interop';

@Component({
    selector: 'object-number-range',
    templateUrl: './swiss-dynamic-object-number-range.component.html',
    styleUrls: ['./swiss-dynamic-object-number-range.component.scss'],
})
export class SwissDynamicObjectNumberRangeComponent implements OnInit {
    objectType = input<string | null | undefined>();
    options$: BehaviorSubject<ObjectRangeOption[]> = new BehaviorSubject([] as ObjectRangeOption[]);
    valueChangedOutput = output<{ key: string, value: string | undefined }>();
    objectTypeChanged$: Observable<string | null | undefined> = toObservable(this.objectType).pipe(takeUntilDestroyed());
    protected selectedObjectNumber?: ObjectRangeOption;

    constructor(private data: ObjektDataService) {

    }

    ngOnInit(): void {
        this.objectTypeChanged$.pipe(
            filter(type => type !== undefined && type !== null),
            switchMap(type => this.data.getObjectRangeOptions(type)),
            tap(options => {
                if (options.length === 0) {
                    options.push({id: undefined, description: 'Keine Angabe'});
                }

                this.options$.next(options);
                this.selectedObjectNumber = options[0];
                this.valueChangedOutput.emit({key: 'ObjectNumberRange', value: this.selectedObjectNumber.id});
            })
        ).subscribe();
    }

    onSelectionChange($event: MatSelectChange): void {
        this.valueChangedOutput.emit({key: 'ObjectNumberRange', value: this.selectedObjectNumber!.id});
    }
}
